<!-- 学习班 修改 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div slot="header">
        <span>1. 修改开班单位名称</span>
      </div>

      <div class="form_box__item">
        <div class="form_box__item__input">
          <el-input v-model="title" placeholder="请输入开班单位名称" ref="input_title"></el-input>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish" >更新</el-button>
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { classunitEditInitApi, classunitEditSaveApi } from "@/api/module/classunit/classunit";

export default {
  name: "ClassunitEdit",
  
  mixins: [BaseVue],
  
  data() {
    return {
      loading: false,
      title: "",
      id: ""
    };
  },
  
  methods: {
    publish() {
      this.loading = true;
      
      const data = {
        id: this.id,
        title: this.title
      };
      
      classunitEditSaveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功,稍后该标签页会关闭！",
            type: "success"
          });
          setTimeout(() => {
            window.close();
          }, 2000);
        }).finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    
    classunitEditInitApi(this.id)
      .then(response => {
        this.title = response.title;
      }).finally(() => {
        this.loading = false;
      });
  }
};
</script>
<style scoped>
</style>

